import React from 'react'
import PropTypes from 'prop-types'
import Spinner from '../ui/Spinner'

const WRAPPER_CLASSES = 'tw:flex tw:flex-col tw:items-center tw:justify-center '
  + 'tw:gap-6 tw:py-6 tw:text-center'

const TEXT_CLASSES = 'tw:m-0! tw:text-lg! tw:font-semibold! tw:text-ds-neutral-highest'

const Loader = ({ showText = true, size = 'medium', text = 'Chargement...' }) => (
  <div className={WRAPPER_CLASSES} role="status">
    <Spinner size={size} />
    {showText ? <p className={TEXT_CLASSES}>{text}</p> : null}
  </div>
)

Loader.propTypes = {
  showText: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  text: PropTypes.string
}

Loader.defaultProps = {
  showText: true,
  size: 'medium',
  text: 'Chargement...'
}

export default Loader
